@if (!dismissed) {
  <div
    class="alert"
    [ngClass]="alertClass"
    [class.alert-dismissible]="dismissible"
    role="alert"
    >
    @if (dismissible) {
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="onClose()"
        >
        <span aria-hidden="true">&times;</span>
      </button>
    }
    <ng-content></ng-content>
  </div>
}
